import { AllActions } from '../../shared/redux/types';
import * as discussionActions from '../discussion/actions';
import { NormalizedSendingMessage } from '../discussion/types';
import * as inTripReviewActions from '../in-trip-review/actions';
import * as messageTemplatesActions from '../message-template/actions';
import * as preTripReviewActions from '../pre-trip-review/actions';

import { EntitiesState } from './types';

const initialState = {
    agent: {},
    discussion: {},
    messageTemplate: {},
    status: {
        searchInArchived: undefined,
        discussion: {},
        messageTemplate: undefined,
    },
};

export const entitiesReducer = (
    state: EntitiesState = initialState,
    action: AllActions,
): EntitiesState => {
    switch (action.type) {
        case preTripReviewActions.fetchPreTripReviewsSuccessAction: {
            return {
                ...state,
                preTripReview: action.response,
            };
        }
        case inTripReviewActions.fetchInTripReviewsSuccessAction: {
            return {
                ...state,
                inTripReview: action.response,
            };
        }
        case preTripReviewActions.removePreTripReviewSuccessAction:
            return {
                ...state,
                preTripReview: undefined,
            };
        case inTripReviewActions.removeInTripReviewSuccessAction:
            return {
                ...state,
                inTripReview: undefined,
            };

        case messageTemplatesActions.getAllMessageTemplatesSuccessAction:
            return {
                ...state,
                messageTemplate: {
                    ...state.messageTemplate,
                    ...action.messageTemplates,
                },
            };
        case messageTemplatesActions.updateMessageTemplateSuccessAction:
            return {
                ...state,
                messageTemplate: {
                    ...state.messageTemplate,
                    ...action.messageTemplate,
                },
            };
        case messageTemplatesActions.postNewMessageTemplateSuccessAction:
            return {
                ...state,
                messageTemplate: {
                    ...state.messageTemplate,
                    ...action.messageTemplate,
                },
            };
        case messageTemplatesActions.deleteMessageTemplateRequestAction:
            return {
                ...state,
                messageTemplate: Object.fromEntries(
                    Object.entries(state.messageTemplate).filter(
                        ([, messageTemplate]) => messageTemplate.id !== action.id,
                    ),
                ),
            };
        case discussionActions.getDraftMessageSuccessAction:
            return {
                ...state,
                discussion: {
                    ...state.discussion,
                    [action.dossierId]: {
                        ...state.discussion[action.dossierId],
                        draftMessage: action.draftMessage,
                        htmlDraftMessage: action.htmlDraftMessage,
                        draftMessageMetadata:
                            state.discussion[action.dossierId]?.draftMessageMetadata,
                    },
                },
            };
        case discussionActions.getMessageSuccessAction: {
            const { dossierId, sendingMessageId } = action;

            if (!sendingMessageId) {
                return state;
            }
            return {
                ...state,
                discussion: {
                    ...state.discussion,
                    [dossierId]: {
                        ...state.discussion[dossierId],
                        draftMessage: undefined,
                        htmlDraftMessage: undefined,
                        draftMessageMetadata: undefined,
                        sendingMessage: {
                            ...state.discussion[dossierId].sendingMessage,
                            [sendingMessageId]: undefined,
                        },
                    },
                },
            };
        }
        case discussionActions.sendMessageRequestAction: {
            const { dossierId, content, contentHtml, sendingMessageId } = action;
            const sendingMessage: NormalizedSendingMessage =
                state.discussion[dossierId]?.sendingMessage || {};
            return {
                ...state,
                discussion: {
                    ...state.discussion,
                    [dossierId]: {
                        ...state.discussion[dossierId],
                        sendingMessage: {
                            ...sendingMessage,
                            [sendingMessageId]: {
                                ...sendingMessage[sendingMessageId],
                                content,
                                contentHtml,
                                id: sendingMessageId,
                            },
                        },
                        draftMessage: '',
                        htmlDraftMessage: '',
                        draftMessageMetadata: undefined,
                    },
                },
            };
        }
        case discussionActions.saveDraftMessageAction: {
            const { draftMessage, htmlDraftMessage, dossierId, metadata } = action;
            return {
                ...state,
                discussion: {
                    ...state.discussion,
                    [dossierId]: {
                        ...state.discussion[dossierId],
                        draftMessage: draftMessage,
                        htmlDraftMessage: htmlDraftMessage,
                        draftMessageMetadata: metadata,
                    },
                },
            };
        }
        case discussionActions.scheduleMessageSuccessAction: {
            const {
                dossierId,
                content,
                contentHtml,
                scheduledDate,
                id,
                authorId,
                sendingMessageId,
            } = action;
            return {
                ...state,
                discussion: {
                    ...state.discussion,
                    [dossierId]: {
                        ...state.discussion[dossierId],
                        draftMessage: undefined,
                        htmlDraftMessage: undefined,
                        draftMessageMetadata: undefined,
                        scheduledMessage: {
                            id,
                            content,
                            contentHtml,
                            scheduledDate,
                            authorId,
                        },
                        ...(sendingMessageId && {
                            sendingMessage: {
                                ...state.discussion[dossierId].sendingMessage,
                                [sendingMessageId]: undefined,
                            },
                        }),
                    },
                },
            };
        }
        case discussionActions.fetchScheduledMessagesSuccessAction: {
            const { dossierId, content, contentHtml, scheduledDate, id, authorId, attachments } =
                action;
            return {
                ...state,
                discussion: {
                    ...state.discussion,
                    [dossierId]: {
                        ...state.discussion[dossierId],
                        scheduledMessage: {
                            id,
                            content,
                            contentHtml,
                            scheduledDate,
                            authorId,
                            attachments,
                        },
                    },
                },
            };
        }
        case discussionActions.deleteScheduledMessageSuccessAction: {
            const { dossierId } = action;
            return {
                ...state,
                discussion: {
                    ...state.discussion,
                    [dossierId]: {
                        ...state.discussion[dossierId],
                        scheduledMessage: null,
                    },
                },
            };
        }
        default:
            return state;
    }
};
